export default {
  list: {
    title: 'shippings',
    name: 'shippings',
    class: 'min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center',
    sousTable: true,
    options: {
      defaultPageSize: 5,
      actions: {
        isActive: true,
        method: true,
        name: 'Actions',
        buttons: [
          {
            text: 'change_status',
            icon: 'update',
            action: 'changestatus',
            color: 'primary',
            class: '',
          },
          {
            text: 'print_list',
            icon: 'print',
            action: 'print',
            color: 'primary',
            class: '',
          },
          {
            text: 'print_delivry',
            icon: 'print',
            action: 'printdDelivry',
            color: 'primary',
            class: '',
          },
        ],
      },
    },
    columns: [
      {
        type: 'checkbox',
        elements: [
          {
            items: [
              {
                class: '',
                type: 'checkbox',
              },
            ],
          },
        ],
      },
      {
        name: 'orderid',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'order_id',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'order-date',
        elements: [
          {
            items: [
              {
                class: '',
                date: true,
                name: 'createdAt',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'seller',
        elements: [
          {
            items: [
              {
                class: 'ouka',
                name: 'seller',
                elements: [
                  {
                    items: [
                      {
                        name: 'company',
                        class: 'font-light text-gray-700',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: 'source',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'source',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'trakingnumber',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'trackingNumber',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'Order',
        model: 'shippings',
        title: 'products',
      },
      {
        name: 'totalprice',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'totalPrice',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'courier',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'courier',
                elements: [
                  {
                    items: [
                      {
                        name: 'fullName',
                        class: 'font-bold',
                        icone: 'airport_shuttle',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: 'city',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'order',
                elements: [
                  {
                    items: [
                      {
                        name: 'city',
                        class: 'font-bold',
                        icone: 'map',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: 'status',
        class: '',
        elements: [
          {
            items: [
              {
                class: 'border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none',
                name: 'status',
                options: item => {
                  switch (item) {
                    case 'to prepare':
                      return 'color: rgb(233 147 19); border-color: rgb(233 147 19);';
                    case 'prepared':
                      return 'color:rgb(8, 194, 226); border-color: rgb(8, 194, 226);';
                    case 'shipped':
                      return 'color:rgb(106 71 9); border-color: rgb(106 71 9);';
                    case 'delivered':
                      return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
                    case 'paid':
                      return 'color:rgb(194, 168, 27); border-color: rgb(194, 168, 27);';
                    case 'processed':
                      return 'color:rgb(215, 26, 230); border-color: rgb(215, 26, 230);';
                    case 'cancelled':
                      return 'color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);';
                    case 'refused':
                      return 'color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);';
                    case 'postponed':
                      return 'color: rgb(227 129 210); border-color: rgb(227 129 210);';
                    case 'rembourser':
                      return 'color: #080808; border-color: #080808;';
                    case 'unreachable':
                      return 'color: rgb(141 8 118); border-color: rgb(141 8 118);';
                    case 'pending return':
                      return 'color: rgb(227 129 210); border-color: rgb(227 129 210);';
                    case 'return':
                      return 'color: rgb(141 8 118); border-color: rgb(141 8 118);';
                    case 'picked up':
                      return 'color: rgb(75, 0, 130); border-color: rgb(75, 0, 130);';
                    case 'reprogram':
                      return 'color: rgb(49, 120, 115); border-color: rgb(49, 120, 115);';
                    case 'interested':
                      return 'color: rgb(30, 144, 255); border-color: rgb(30, 144, 255);';
                    default:
                      return 'color: rgb(0, 0, 0); border-color: rgb(0, 0, 0);';
                  }
                },
              },
            ],
          },
        ],
      },
    ],
    columnsDialog: {
      details: 'order',
      name: 'details',
      elements: [
        {
          class: '',
          name: 'customer name',
          referent: 'order',
          attribut: 'customer',
          items: [
            {
              class: '',
              elements: [
                {
                  items: [
                    {
                      name: 'fullName',
                      class: 'font-bold',
                      icone: 'contacts',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          class: '',
          name: 'customer phone',
          referent: 'order',
          attribut: 'customer',
          items: [
            {
              class: '',
              elements: [
                {
                  items: [
                    {
                      name: 'phone',
                      class: 'font-light text-gray-700',
                      icone: 'local_phone',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          class: '',
          name: 'address',
          referent: 'order',
          attribut: 'customer',
          items: [
            {
              name: 'address',
            },
          ],
        },
        {
          class: '',
          name: 'totalprice',
          referent: 'order',
          items: [
            {
              name: 'totalPrice',
            },
          ],
        }
      ],
      sousElements: [
        {
          class: '',
          name: 'image',
          referent: 'product',
          items: [
            {
              name: 'picture',
            },
          ],
        },
        {
          class: '',
          name: 'name',
          referent: 'product',
          items: [
            {
              name: 'name',
            },
          ],
        },
        {
          class: '',
          name: 'unit_price',
          items: [
            {
              name: 'unitPrice',
            },
          ],
        },
        {
          class: '',
          name: 'quantity',
          items: [
            {
              name: 'quantity',
            },
          ],
        },
      ],
    },
    actions: {
      name: 'actions',
      width: '10px',
      class: 'justify-end',
      elements: [
        {
          icone: 'refresh',
          color: 'success',
          key: 'update',
          role: true,
          tooltip: 'Refresh',
        },
        {
          icone: 'remove_red_eye',
          color: 'success',
          key: 'read',
          id: '',
          role: true,
          link: '/shippings/view',
          tooltip: 'Update',
        },
        {
          icone: 'edit',
          color: 'success',
          role: true,
          key: 'update',
          link: '/shippings/edit',
          tooltip: 'Update',
        },
        {
          icone: 'delete',
          color: 'danger',
          role: true,
          key: 'delete',
          tooltip: 'Delete',
        },
      ],
    },
    filters: {
      name: 'zones',
      hasFilterdate: false,
      elements: {
        search: {
          options: {
            icon: 'search',
            label: 'search',
            class: '',
            hint: 'search_shipping',
          },
          value: null,
          type: 'search',
          validate: {
            trim: true,
            required: false,
            minlength: 0,
          },
        },
        champs: [
          {
            label: 'status',
            key: 'status',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'delivered status',
            key: 'delivered_status',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'Api Status',
            key: 'api_status',
            name: 'api_status',
            value: null,
            values: [],
            class:
              'py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'seller',
            key: 'seller',
            name: 'company',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'product',
            key: 'product',
            name: 'name',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'Affiliate stores',
            key: 'affiliate_stores',
            name: 'affiliate_stores',
            value: null,
            values: [],
            class:
              'py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'courier',
            key: 'courier',
            name: 'fullName',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'Post confirmation',
            key: 'teleconsultant',
            name: 'fullName',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'city',
            key: 'city',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'Shipping date',
            key: 'Range_date',
            value: null,
            placeholder: 'Date Range ...',
            type: 'date_range',
            class: 'py-2 text-xs px-2 outline-none block h-full w-full',
          },
          {
            label: 'Facture date',
            key: 'Facture_date',
            value: null,
            placeholder: 'Date Range ...',
            type: 'date_range',
            class: 'py-2 text-xs px-2 outline-none block h-full w-full',
          },
          {
            label: 'From',
            key: 'from',
            value: null,
            placeholder: 'Date',
            type: 'date',
            class: 'py-2 text-xs px-2 outline-none block h-full w-full',
          },
          {
            label: 'To',
            key: 'to',
            value: null,
            placeholder: 'Date',
            type: 'date',
            class: 'py-2 text-xs px-2 outline-none block h-full w-full',
          },
        ],
      },
    },
  },
};
